export default "__VITE_ASSET__DmWJY3oE__"